<template>
  <div>
    <div class="allContent">
<!--      <div class="bgi"></div>-->
      <div class="container" :class="$store.state.user.isNested && 'nestedHeader'">
        <Icon
          class="navbar_icon"
          name="arrow-left"
          @click="$router.push('/order')"
        />
        <div class="productName">榮耀貸</div>
<!--        <Notice />-->
        <OrderInfo
          v-if="busiId"
          @handleRepaymentBtn="handleRepaymentBtn"
          :busiId="busiId"
        ></OrderInfo>

<!--        <div class="bannerImg">-->
<!--          <Swipe-->
<!--            :autoplay="isShowFrame ? '0' : '3000'"-->
<!--            :loop="!isShowFrame"-->
<!--            indicator-color="#FFFFFF"-->
<!--            @change="changeSwipe"-->
<!--          >-->
<!--            <Swipe-item-->
<!--              @click="showFrame(index)"-->
<!--              v-for="(image, index) in images"-->
<!--              :key="index"-->
<!--            >-->
<!--              <div class="swipeImg">-->
<!--                <img v-lazy="image" />-->
<!--              </div>-->
<!--            </Swipe-item>-->
<!--          </Swipe>-->
<!--        </div>-->

        <div style="height:50px;"></div>
      </div>
    </div>
<!--    <SwipeHint-->
<!--      :imageIndex="imageIndex"-->
<!--      :show="isShowFrame"-->
<!--      @closePopup="closePopup"-->
<!--    />-->
    <EnterAmount v-if="isShowOnlineFrame" :payAmount="payAmount" :vaType="order.vaType" @cancel="cancelOnline" @submint="submintOnline"
                 :isShowFrame="isShowOnlineFrame"></EnterAmount>
  </div>
</template>

<script>
import {
  // Swipe, SwipeItem,
  Icon } from "vant";
import OrderInfo from "@/components/orderInfo";
// import Notice from "@/components/notice";
// import SwipeHint from "@/components/swipeHint";
import l from "@/locales";
import EnterAmount from "./components/enterAmount.vue";

import { formatMoney } from "@/utils";
export default {
  components: {
    // Swipe, SwipeItem,
    Icon, OrderInfo,
    // Notice, SwipeHint
    EnterAmount,
  },
  props: {
    applyType: {
      type: [String, Number],
    },
  },
  watch: {},
  data() {
    return {
      l: {
        ...l.home,
        ...l.repayMethods,
        ...l.orderItem,
        ...l.other,
        ...l.tabbar,
      },
      busiId: "",

      images: [
        require("@/assets/home/banner.png"),
        require("@/assets/home/banner2.png"),
        require("@/assets/home/banner3.png"),
      ],
      imageIndex: 0,
      isShowFrame: false,
      order: undefined,
      isShowOnlineFrame: false,

      payAmount: "",
    };
  },
  created() {
    this.busiId = this.$route.query.busiId;
  },
  methods: {
    formatMoney,
    getAmount() {
      let order = this.order;
      order.loan_status = Number(order.loan_status);
      order.bid_status = Number(order.bid_status);
      let amount;
      switch (order.loan_status) {
        case 2:
        case 3:
        case 5:
          amount = order.principal;
          break;
        case 1:
          amount = order.amount2Account;
          break;
        case 4:
        case 6:
          amount = order.remainAmount;
          break;
        case 9:
          amount = order.reach_amount;
          break;
      }
      if (amount.includes(",")) {
        amount = Number(amount.replace(/,/g, ""));
      }
      return amount;
    },
    async submintOnline(data) {
      console.log("submintOnline",data)
      this.payAmount = data.amount;
      this.order.amount = data.amount;
      this.order = {...this.order,...data};
      this.goPay();
    },
    cancelOnline() {
      this.isShowOnlineFrame = false;
    },
    handleRepaymentBtn(order) {
      this.order = order;
      if(order.vaType ==1){

        this.isShowOnlineFrame = true;
        order.amount = this.getAmount();
        console.log("order",order)
        // this.payAmount = order.amount.replace(",", "");
        this.payAmount = order.amount;
      }
      if (order.vaType == 2){
        this.isShowOnlineFrame = true;
        order.amount = this.getAmount();
        console.log("order",order)
        // this.payAmount = order.amount.replace(",", "");
        this.payAmount = order.amount;
        // this.goPay();
      }
    },
    goPay(){
      let order = this.order;
      const userResult = this.$store.state.user.userInfo;
      let params = {
        timestamp: Date.now(),
        // "app_version": "1.0.4",
        referrer: localStorage.getItem("channel"),
        // "af_prt": "channel\u003d"+sessionStorage.getItem("channel"),
        af_prt: localStorage.getItem("channel"),
        sign: "0f656af82eb1da33221a06d1171db265",
        // "pkg_name": "com.loan.starloanh5",
        // "imei": "862209031257508",
        // "appversion": "1.0.4",
        channel: "1",
        // "version": "1.0.4"
      };
      
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        params.pkg_name = "com.loan.starloanh5ios";
      } else if (navigator.userAgent.match(/android/i)) {
        params.pkg_name = "com.loan.starloanh5";
      }

      // console.log("设备类型",system);
      if (userResult?.user_id) {
        params.user_id = userResult.user_id;
      }
      if (userResult?.imei) {
        params.imei = userResult.imei;
      }
      if (userResult?.loginStaticKey) {
        params.loginStaticKey = userResult.loginStaticKey;
      }
      if (order?.repayChannels) {
        params.repayChannels = order.repayChannels;
      }
      if (order?.bank_code) {
        params.bank_code = order.bank_code;
      }
      if (order?.amount) {
        params.amount = order.amount;
      }
      if (order?.vaType) {
        params.vaType = order.vaType;
      }

      if (userResult?.version) {
        params.app_version = userResult.version;
        params.appversion = userResult.version;
        params.version = userResult.version;
      }
      localStorage.setItem(
        "payInfo",
        JSON.stringify({
          ...params,
          busiNo: this.$route.query.busiId,
          ...order,
        })
      );
      this.$router.push("/pay");
    },
    closePopup() {
      this.isShowFrame = false;
    },
    showFrame(index) {
      this.imageIndex = index;
      this.isShowFrame = true;
    },
    changeSwipe(index) {
      this.imageIndex = index;
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.allContent {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #F5F5F5;
  .bgi {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    width: 100%;
    height: 100%;
    background: url("../../assets/order/bgi.png") no-repeat;
    background-size: 100%;
  }
  .container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    padding-top: 22px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #16181A;

    .productName {
      text-align: center;
      margin-bottom: 20px;
    }
    .navbar_icon {
      position: absolute;
      top: 22px;
      left: 16px;
    }

    .container_submit {
      .commit_con {
        padding: 0 15px;

        .button_font {
          margin: 0 auto;
          width: 330px;
          height: 48px;
          background: #232425;
          border: none;
          border-radius: 24px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ebcfa4;
        }
      }
    }
    .bannerImg {
      position: relative;
      box-sizing: border-box;
      margin: 0 20px;
      margin-top: 20px;
      width: calc(100% - 40px);
      height: 110px;
      .swipeImg {
        position: relative;
        width: 100%;
        height: 110px;
        img {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 335px;
          height: 100%;
          border-radius: 14px;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
